// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38tao","type":"styles_type__3r2x5","choices":"styles_choices__3-doR"};